import { Constellation } from '../CelestialPatterns'
import { useNavigate } from 'react-router-dom'

const TestimonialPanel = () => {
  const navigate = useNavigate()
  return (
    <section
      className="w-screen h-screen flex-shrink-0 relative overflow-hidden"
      style={{ background: '#CBB191' }}
    >
      <div className="grain-overlay" />

      {/* Celestial pattern */}
      <div className="absolute top-[-30px] left-[-30px] pointer-events-none">
        <Constellation />
      </div>

      <div className="relative z-10 flex flex-col h-full px-5 sm:px-8 lg:px-[5%] xl:px-[7%] pt-[80px] sm:pt-[84px] lg:pt-[88px] pb-5 sm:pb-6 lg:pb-8 overflow-y-auto lg:overflow-hidden">

        <div className="flex-1 flex flex-col lg:flex-row gap-6 lg:gap-0 items-start min-h-0">

          {/* LEFT — Quote + Meta */}
          <div className="w-full lg:w-[48%] xl:w-[45%] flex flex-col justify-center lg:pr-8 xl:pr-16 min-h-0">

            <blockquote className="mb-6 sm:mb-8 flex-shrink-0">
              <p
                className="font-serif font-light tracking-[-0.01em]"
                style={{ fontSize: 'clamp(1.4rem, 3vw, 3rem)', lineHeight: '1.15', color: '#2B2017' }}
              >
                &ldquo;It felt personal.<br />
                Not <span className="golden-text">generic</span>.&rdquo;
              </p>
            </blockquote>

            <div className="flex items-center gap-4 mb-8 sm:mb-10 flex-shrink-0">
              <div className="w-8 h-px" style={{ background: '#8A6338' }} />
              <div>
                <span
                  className="block font-sans font-medium"
                  style={{ fontSize: 'clamp(0.82rem, 0.9vw, 0.95rem)', color: '#2B2017' }}
                >
                  Early Access User
                </span>
                <span
                  className="font-mono uppercase mt-0.5 block tracking-[0.18em]"
                  style={{ fontSize: 'clamp(6px, 0.65vw, 8px)', color: '#8A7A6A' }}
                >
                  Pune, India
                </span>
              </div>
            </div>

            <div className="flex flex-shrink-0">
              {[
                { label: 'Confidence', value: '94%' },
                { label: 'Transit', value: 'Saturn Rx' },
                { label: 'House', value: '10th' },
              ].map((item, i) => (
                <div
                  key={i}
                  className="pr-5 sm:pr-6 mr-5 sm:mr-6"
                  style={{ borderRight: i < 2 ? '1px solid #A98C6B' : 'none' }}
                >
                  <span
                    className="font-mono uppercase block mb-1 tracking-[0.2em]"
                    style={{ fontSize: 'clamp(5.5px, 0.6vw, 7px)', color: '#8A7A6A' }}
                  >
                    {item.label}
                  </span>
                  <span style={{ fontSize: 'clamp(0.78rem, 0.85vw, 0.88rem)', color: '#2B2017' }}>
                    {item.value}
                  </span>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT — Photo + CTA */}
          <div className="w-full lg:w-[52%] xl:w-[55%] flex flex-col min-h-0">

            <div
              className="relative w-full overflow-hidden flex-shrink-0 mb-6 sm:mb-8 lg:mb-10"
              style={{ borderRadius: '12px', height: 'clamp(200px, 35vh, 380px)', border: '1px solid #A98C6B' }}
            >
              <img
                src="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=800&q=80"
                alt="Testimonial editorial"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
            </div>

            <div>
              <h2
                className="font-serif font-light tracking-[-0.02em] mb-2"
                style={{ fontSize: 'clamp(1.4rem, 3vw, 3rem)', lineHeight: '1.05', color: '#2B2017' }}
              >
                Start understanding yourself.
              </h2>
              <p
                className="mb-5 sm:mb-6"
                style={{ fontSize: 'clamp(0.82rem, 0.9vw, 0.95rem)', color: '#5A4636' }}
              >
                Your next insight is one reading away.
              </p>
              <button
                onClick={() => navigate('/horoscope')}
                className="px-8 py-4 sm:py-5 w-full sm:w-auto font-semibold tracking-[0.08em] uppercase transition-all duration-300 hover:-translate-y-px hover:shadow-lg active:translate-y-0"
                style={{ fontSize: 'clamp(0.8rem, 0.9vw, 0.95rem)', background: '#8A6338', color: '#F5EDE1', borderRadius: '8px' }}
              >
                Generate My Reading
              </button>
            </div>
          </div>
        </div>

        {/* FOOTER */}
        <div
          className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 pt-4 mt-4 flex-shrink-0"
          style={{ borderTop: '1px solid #A98C6B' }}
        >
          <div className="flex items-center gap-1.5">
            <span className="font-serif text-sm font-light tracking-[0.04em]" style={{ color: '#2B2017' }}>Astro</span>
            <span className="font-serif text-sm font-light tracking-[0.04em] golden-text">ML</span>
          </div>
          <p
            className="font-mono"
            style={{ fontSize: 'clamp(7px, 0.7vw, 8px)', color: '#8A7A6A', letterSpacing: '0.05em' }}
          >
            AI-powered Astrology, Palmistry & Tarot.
          </p>
        </div>
      </div>
    </section>
  )
}

export default TestimonialPanel
